<div portalToBody class="modal fade" id="imagePreviewModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content image-preview-modal">
      <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Cerrar"></button>
      <img [src]="previewImage" class="preview-full" [alt]="alt" loading="lazy" />
    </div>
  </div>
</div>